import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const manutencaoPreventivaRoutes: RouteRecordRaw[] = [
    {
        path: "/manutencao-preventiva/apontamento",
        name: "manutencao-apontamento",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_MANUTENCAO_N1_OPERADOR},
        component: () => import("@/modules/manutencaoPreventiva/pages/PageManutencaoOperador.vue")
    },
    {
        path: "/manutencao-preventiva/operacoes",
        name: "manutencao-operacoes",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_MANUTENCAO_N1_GESTAO},
        component: () => import("@/modules/manutencaoPreventiva/pages/PageManutencaoOperacoes.vue")
    },
    {
        path: "/manutencao-preventiva/plano",
        name: "manutencao-plano",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_MANUTENCAO_N1_GESTAO},
        component: () => import("@/modules/manutencaoPreventiva/pages/PageManutencaoPlanoCT.vue")
    },
    {
        path: "/manutencao-preventiva/auditoria",
        name: "manutencao-auditoria",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_MANUTENCAO_N1_GESTAO},
        component: () => import("@/modules/manutencaoPreventiva/pages/PageManutencaoAuditoria.vue")
    },
];
